import { Component, OnInit } from '@angular/core';

import { DashboardServiceService } from '../../services/dashboard-service.service';
import { MatDialog } from '@angular/material/dialog';
import { UpdateNotificationComponent } from '../../modals/update-notification/update-notification.component';
import { GlobalService } from '../../../../services/global.service';
import { RemoveCollaboratosComponent } from '../../modals/remove-collaboratos/remove-collaboratos.component';
import { MapServiceService } from 'src/app/modules/map/services/Map-service/map-service.service';

@Component({
  selector: 'app-collaboration',
  templateUrl: './collaboration.component.html',
  styleUrls: ['./collaboration.component.css'],
})
export class CollaborationComponent implements OnInit {
  text: any;
  moreOptions: any;
  maps: any;
  userHaveAccess: any;
  pendingUsers: any;
  current_users: any;
  editCurrentCollab: any;

  isLoaded: any = false;
  emails: any = '';
  options: any = '0';
  previewText: any = '';
  collaborationData: any = [];
  cancelArray: any = [];
  check: any = [];
  productType: any = [];

  constructor(
    private mapService: MapServiceService,
    public dashboard: DashboardServiceService,
    private dialog: MatDialog,
    private global: GlobalService
  ) {
    //
  }

  ngOnInit(): void {
    //handle dynamic modal
    this.mapService.dynamicModalCheck(
      '',
      this.mapService.isLiveShareLink,
      true,
      false
    );

    if (this.dashboard.mapsAndProfile != null) {
      this.updateData();
    }
    this.dashboard.dataLoaded.subscribe(() => {
      this.updateData();
    });
  }


  //render data in html based on scenarios
  updateData(): any {
    this.collaborationData = this.dashboard.mapsAndProfile.adds_on;

    //check if user have access to collaborator angd getting product type for seats
    for (let i = 0; i < this.collaborationData.length; i++) {
      if (
        this.collaborationData[i].status == 'active' ||
        this.collaborationData[i].status == 'canceled'
      ) {
        // this.userHaveAccess = true; fix the collaboration access issue when no seat but addons available
        if (
          (this.collaborationData[i].plan_code == 'seats' ||
            this.collaborationData[i].plan_code == 'seats-yearly') &&
          this.productType.length == 0
        ) {
          this.productType.push('1');
          this.userHaveAccess = true;
        } else if (
          (this.collaborationData[i].plan_code == 'seats-wv-1-month' ||
            this.collaborationData[i].plan_code == 'seats-wv-yearly') &&
          this.productType.length == 0
        ) {
          this.productType.push('2');
          this.userHaveAccess = true;
        } else if (
          (this.collaborationData[i].plan_code == 'seats-wdv' ||
            this.collaborationData[i].plan_code == 'seats-wdv-yearly') &&
          this.productType.length == 0
        ) {
          this.productType.push('5');
          this.userHaveAccess = true;
        } else if (
          this.collaborationData[i].plan_code == 'seats-mp-annual' &&
          this.productType.length == 0
        ) {
          this.productType.push('3');
          this.userHaveAccess = true;
        }
      }
    }
    this.text = this.dashboard.mapsAndProfile.collab_text;
    if (this.collaborationData.length == 0) {
      this.collaborationData = null;
    }
    this.pendingUsers = this.dashboard.mapsAndProfile.pending_users;
    const data = this.dashboard.mapsAndProfile.current_users;
    this.current_users = this.uniqByKeepFirst(data, (it: any) => it.subscriber)
    if (this.pendingUsers.length != 0) {
      //sort pending users
      this.pendingUsers.sort((a: any, b: any) =>
        a.email.localeCompare(b.email)
      );
    }
    if (this.current_users.length != 0) {
      //sort current users
      this.current_users.sort((a: any, b: any) =>
        a.subscriber__first_name.localeCompare(b.subscriber__first_name)
      );
    }
    this.maps = this.dashboard.mapsAndProfile.My_maps;
    this.isLoaded = true;
  }
  uniqByKeepFirst(a: any, key: any) {
    const seen = new Set();
    return a.filter((item: any) => {
        const k = key(item);
        return seen.has(k) ? false : seen.add(k);
    });
}
  showMoreOptions(): void {
    this.moreOptions = true;
  }

  back(): void {
    this.moreOptions = false;
  }

  isEditCurrentCollab(): void {
    this.editCurrentCollab = true;
  }

  cancelCurrentCollab(): void {
    this.editCurrentCollab = false;
  }


  //change event for canceling collaborators
  onChangeCurrent(event: any, i: any) {
    if (event.target.checked) {
      this.check[i] = true;
      const index = this.cancelArray.indexOf(event.target.value);

      if (index != -1) {
        this.cancelArray.splice(index, 1);
      } else {
        this.cancelArray.push(event.target.value);
      }
    } else {
      const index = this.cancelArray.indexOf(event.target.value);

      if (index != -1) {
        this.cancelArray.splice(index, 1);
      }
      this.check[i] = false;
    }
  }

  //cancel current collaborators
  cancelAllCollab(): void {
    if (this.cancelArray.length == 0) {
      this.editCurrentCollab = false;
    } else {
      const body = {
        collaborator_ids: this.cancelArray,
      };
      const dialogRef = this.dialog.open(RemoveCollaboratosComponent, {
        panelClass: 'app-full-bleed-dialog',
        position: {
          top: '10%',
          left: '35.1%',
        },
        backdropClass: 'bdrop',
      });

      dialogRef.afterClosed().subscribe(() => {
        if (this.dashboard.callApi) {
          this.global.toggleLoader(true);
          this.dashboard.deleteCollaborators(body).subscribe((res) => {
            if (res) {
              this.dashboard.getDashboardData().subscribe((res: any) => {
                this.dashboard.mapsAndProfile = res;
                this.editCurrentCollab = false;
                this.cancelArray = [];
                this.check = [];
                this.ngOnInit();
              });
            }
          });
        }
      });
    }
  }

  //cancel pending invitation
  cancelInvitation(id: any): void {
    const body = {
      collaborator_ids: [id],
    };
    this.dashboard.deleteCollaborators(body).subscribe((res) => {
      if (res) {
        this.dashboard.getDashboardData().subscribe((res: any) => {
          this.dashboard.mapsAndProfile = res;
          this.ngOnInit();
        });
      }
    });
  }

  //send collaborator invitation
  send(): void {
    this.dashboard
      .sendCollabEmail(
        this.productType.toString(),
        this.emails,
        this.options,
        this.previewText
      )
      .subscribe((res) => {
        if (res) {
          const dialogRef = this.dialog.open(UpdateNotificationComponent, {
            disableClose: true,
            data: { message: 'Invitation sent successfully ' },
            panelClass: 'app-full-bleed-dialog',

            position: {
              top: '10%',
              left: '40.1%',
            },
            backdropClass: 'bdrop',
          });

          dialogRef.afterClosed().subscribe(() => {
            this.global.toggleLoader(true);
            this.dashboard.getDashboardData().subscribe((res: any) => {
              this.dashboard.mapsAndProfile = res;
              this.emails = [];
              this.ngOnInit();
            });
          });
          this.moreOptions = false;
        }
      });
  }


  //resend email to pending collaborator
  resend(email: any, type: any): void {
    if (type == 'pv') {
      this.productType.push('1');
    } else if (type == 'wv') {
      this.productType.push('2');
    } else if (type == 'wdv') {
      this.productType.push('5');
    } else if (type == 'mp') {
      this.productType.push('3');
    }
    this.dashboard
      .sendCollabEmail(this.productType.toString(), email, '0', '')
      .subscribe((res) => {
        if (res) {
          const dialogRef = this.dialog.open(UpdateNotificationComponent, {
            disableClose: true,
            data: { message: 'Invitation sent successfully ' },
            panelClass: 'app-full-bleed-dialog',
            position: {
              top: '10%',
              left: '40.1%',
            },
            backdropClass: 'bdrop',
          });

          dialogRef.afterClosed().subscribe(() => {
            this.global.toggleLoader(true);
            this.dashboard.getDashboardData().subscribe((res: any) => {
              this.dashboard.mapsAndProfile = res;
              this.emails = [];
              this.ngOnInit();
            });
          });
          this.moreOptions = false;
        }
      });
  }


  //map select
  onChange(evt: any): void {
    this.options = evt.target.value;
  }
}
